import type { Theme } from '@emotion/react';
import { buildTheme } from 'common-ui';
import merge from 'lodash/merge';
import type { CommonThemeVars, ThemeCreateFunction } from 'tsconfig/types';
import {
  buildThemeVarsAPACNewstf,
  buildThemeMixinsAPACNewstf,
  buildThemeWidgetStylesAPACNewstf,
} from 'dw-apac-newstf/theme-foundation';

const createTheme: ThemeCreateFunction = () =>
  buildTheme(
    (vars: Pick<Theme, CommonThemeVars>) => merge({}, buildThemeVarsAPACNewstf(vars)),
    (vars: Omit<Theme, 'mixins' | 'widgets'>) => buildThemeMixinsAPACNewstf(vars),
    (vars: Omit<Theme, 'widgets'>) => buildThemeWidgetStylesAPACNewstf(vars),
  );

export default createTheme;
